import { assertArray, assertTrue } from "../../../../utils/assert";
import { GetVehiclesGeopositionFn, VehicleGeoposition } from "../../../../../rest/GetVehiclesGeoposition";
import { VehicleGeopositionActions } from "../flux";
import { GoogleMapLoader } from "../../../../utils/GoogleMapLoader";
import { FlagActions } from "../../../../flux/Flag";
import { ErrorActions } from "../../../../flux/Error";
import { appNavigator } from "../../../../routes";

type VehicleIdsGetter = () => (string|number)[];

export class ShowVehicleGeopositionCommand
{
    private readonly vehicleGeopositionActions = new VehicleGeopositionActions();
    private readonly errorActions = new ErrorActions();
    private readonly inProgressActions = new FlagActions();
    private readonly alertActions = new FlagActions();

    constructor(private getIds: VehicleIdsGetter,
        private getVehiclesGeoposition: GetVehiclesGeopositionFn,
        private googleMapLoader: GoogleMapLoader,
        private errorToken: string,
        private inProgressToken: string,
        private alertStoreToken: string)
    {
    }

    execute = () => {
        const ids = this.getIds();
        assertArray(ids);
        assertTrue(ids.length > 0);

        let vehicleGeopositions: VehicleGeoposition[];
        
        this.inProgressActions.set(this.inProgressToken);
        this.getVehiclesGeoposition({ Vehicle: ids })
            .then(res => {
                vehicleGeopositions = res.Vehicle;
                return this.googleMapLoader.loadMapFor(res.Gapik);
            })
            .then(() => {
                this.inProgressActions.reset(this.inProgressToken);

                const hasGeoData = vehicleGeopositions.some(v => Array.isArray(v.Geoposition) && v.Geoposition.length > 0);
                if(!hasGeoData) {
                    this.alertActions.set(this.alertStoreToken);
                } else {
                    this.vehicleGeopositionActions.setVehicleGeoposition(vehicleGeopositions);
                    appNavigator.goToVehicleGeopositionPage();
                }
            })
            .catch((err: Error) => {
                this.inProgressActions.reset(this.inProgressToken);
                this.errorActions.setError(err, this.errorToken, 5*1000);
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/commands/ShowVehicleGeopositionCommand.ts